<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section mb-3">
        <div class="container-fluid">
          <div class="grid justify-content-between">
            <div class="col">
              <div class="">
                <div class="surface-100 p-3 text-lg font-bold">
                  Previous Tickets
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </template>
    <section class="page-section">
      <div class="container-fluid">
        <div class="grid">
          <div class="col comp-grid">
            <div class="">
              <div class="flex align-items-center justify-content-around">
                <div v-if="searchText" :class="filterTagClass">
                  Search
                  <Chip
                    class="font-medium px-2 py-1"
                    removable
                    @remove="clearSearch()"
                    >{{ searchText }}</Chip
                  >
                </div>
              </div>
              <div class="">
                <div>
                  <template v-if="showBreadcrumbs && $route.query.tag">
                    <Breadcrumb
                      :home="{ icon: 'pi pi-home', to: '/complaints' }"
                      :model="pageBreadCrumb"
                    />
                  </template>
                  <div class="relative-position">
                    <div class="grid">
                      <div class="col-12">
                        <div class="">
                          <!-- Master Page Start -->
                          <!-- page records template -->
                          <div class="page-records" v-if="!loading">
                            <div class="grid justify-content-start">
                              <template v-for="(data, i) of records" :key="i">
                                <div
                                  v-if="complaintId != data.complaint_id"
                                  class="col-12"
                                >
                                  <div class="card">
                                    <div class="grid align-items-center mb-2">
                                      <div class="col text-sm text-500">
                                        Ticket Number:
                                      </div>
                                      <div class="col text-right">
                                        <div class="font-bold">
                                          <Button
                                            class="p-button-link p-0 text-left"
                                            :label="data.ticket_id"
                                            target="__blank"
                                            v-if="data.ticket_id"
                                            @click="
                                              app.navigateTo(
                                                `/complaints/view/${data.complaint_id}`,
                                                `_blank`
                                              )
                                            "
                                          />
                                        </div>
                                      </div>
                                    </div>

                                    <Accordion :activeIndex="0">
                                      <AccordionTab header="Complaint Info">
                                        <div class="grid align-items-center">
                                          <div class="col text-sm text-500">
                                            Type:
                                          </div>
                                          <div class="col text-right">
                                            <div class="font-bold">
                                              {{
                                                $utils.capitalize(
                                                  data.complaint_type
                                                )
                                              }}
                                            </div>
                                          </div>
                                        </div>
                                        <hr />
                                        <div class="grid align-items-center">
                                          <div class="col text-sm text-500">
                                            Status:
                                          </div>
                                          <div class="col text-right">
                                            <div class="font-bold">
                                              <Tag
                                                v-if="data.status == 'opened'"
                                                class="bg-cyan-700"
                                                rounded
                                                :value="
                                                  $utils.capitalize(data.status)
                                                "
                                              ></Tag>
                                              <Tag
                                                v-else-if="
                                                  data.status == 'closed'
                                                "
                                                class="bg-green-400"
                                                rounded
                                                :value="
                                                  $utils.capitalize(data.status)
                                                "
                                              ></Tag>
                                              <Tag
                                                v-else-if="
                                                  data.status == 'prank'
                                                "
                                                class=""
                                                rounded
                                                severity="warning"
                                                :value="
                                                  $utils.capitalize(data.status)
                                                "
                                              ></Tag>
                                              <Tag
                                                v-else
                                                class="bg-gray-500"
                                                rounded
                                                :value="
                                                  $utils.capitalize(data.status)
                                                "
                                              ></Tag>
                                            </div>
                                          </div>
                                        </div>
                                        <hr />
                                        <div class="grid align-items-center">
                                          <div class="col text-sm text-500">
                                            Action Taken:
                                          </div>
                                          <div class="col text-right">
                                            <div class="font-bold">
                                              {{ data.action_taken }}
                                            </div>
                                          </div>
                                        </div>
                                        <hr />
                                        <div class="grid">
                                          <div class="col-12 text-sm text-500">
                                            Message/Description:
                                          </div>
                                          <div class="col-12">
                                            <div class="font-bold text-teal-500">
                                              {{ data.message }}
                                            </div>
                                          </div>
                                        </div>
                                        <hr />
                                        <div class="grid align-items-center">
                                          <div class="col text-sm text-500">
                                            Date:
                                          </div>
                                          <div class="col text-right">
                                            <div class="font-bold">
                                              {{
                                                $utils.humanDatetime(
                                                  data.date_created
                                                )
                                              }}
                                            </div>
                                          </div>
                                        </div>
                                      </AccordionTab>
                                    </Accordion>

                                    <div class="flex justify-content-end mt-1">
                                      <SplitButton
                                        class="p-button p-button-raised p-button-text p-button-sm"
                                        :model="getActionMenuModel(data)"
                                      >
                                        <i></i>
                                      </SplitButton>
                                    </div>
                                  </div>
                                </div>
                              </template>
                            </div>
                          </div>
                          <!-- page loading indicator -->
                          <template v-if="loading">
                            <div>
                              <DataTable
                                :value="[1, 2, 3, 4]"
                                responsiveLayout="scroll"
                              >
                                <Column>
                                  <template #body>
                                    <Skeleton />
                                  </template>
                                </Column>
                                <Column>
                                  <template #body>
                                    <Skeleton borderRadius="16px" />
                                  </template>
                                </Column>
                                <Column>
                                  <template #body>
                                    <Skeleton />
                                  </template>
                                </Column>
                              </DataTable>
                            </div>
                          </template>
                          <!-- end of page loading indicator-->
                          <!-- Empty record -->
                          <template v-if="pageReady && !records.length">
                            <div
                              class="p-3 my-3 text-500 text-lg font-medium text-center"
                            >
                              No previous tickets found
                            </div>
                          </template>
                          <!-- end of empty record-->
                          <!-- pagination component-->
                          <template v-if="showFooter">
                            <div class="">
                              <div class="flex justify-content-between">
                                <div class="flex-grow-0">
                                  <div class="flex"></div>
                                </div>
                                <div class="flex-grow-1">
                                  <div
                                    v-if="pageReady && totalPages > 1"
                                    class="flex justify-content-center"
                                  >
                                    <div class="m-2">
                                      <Button
                                        :disabled="pagination.page <= 1"
                                        class="p-button-sm"
                                        label="Previous"
                                        @click="loadPreviousPage()"
                                        icon="pi pi-arrow-left"
                                      />
                                    </div>
                                    <div class="m-2">
                                      <Button
                                        :disabled="
                                          pagination.page >= totalPages
                                        "
                                        label="Next"
                                        class="p-button-sm"
                                        @click="loadNextPage()"
                                        icon="pi pi-arrow-right"
                                        icon-pos="right"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </template>
                          <!-- end of pagination component-->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script setup>
import { reactive, toRefs, onMounted, watch } from "vue";
import { utils } from "@/utils";
import { useApp } from "@/composables/app.js";
import { useAuth } from "@/composables/auth";
import { useListPage } from "@/composables/listpage.js";
import { useRoute, useRouter } from "vue-router";
const props = defineProps({
  primaryKey: {
    type: String,
    default: "complaint_id",
  },
  pageName: {
    type: String,
    default: "complaints",
  },
  routeName: {
    type: String,
    default: "complaintssublist",
  },
  apiPath: {
    type: String,
    default: "complaints/sublist",
  },
  paginate: {
    type: Boolean,
    default: true,
  },
  showHeader: {
    type: Boolean,
    default: true,
  },
  showFooter: {
    type: Boolean,
    default: true,
  },
  showBreadcrumbs: {
    type: Boolean,
    default: true,
  },
  exportButton: {
    type: Boolean,
    default: true,
  },
  importButton: {
    type: Boolean,
    default: false,
  },
  multiCheckbox: {
    type: Boolean,
    default: false,
  },
  emptyRecordMsg: {
    type: String,
    default: "No previous tickets found",
  },
  titleBeforeDelete: {
    type: String,
    default: "Delete record",
  },
  msgBeforeDelete: {
    type: String,
    default: "Are you sure you want to delete this record?",
  },
  msgAfterDelete: {
    type: String,
    default: "Record deleted successfully",
  },
  page: {
    type: Number,
    default: 1,
  },
  limit: {
    type: Number,
    default: 3,
  },
  mergeRecords: {
    // for infinite loading
    type: Boolean,
    default: false,
  },
  search: {
    type: String,
    default: "",
  },
  fieldName: null,
  fieldValue: null,
  complaintId: null,
  refreshToken: null,
  sortBy: {
    type: String,
    default: "",
  },
  sortType: {
    type: String,
    default: "", //desc or asc
  },
  isSubPage: {
    type: Boolean,
    default: false,
  },
  filterTagClass: {
    type: String,
    default:
      "surface-card p-2 text-500 flex-grow-1 text-center m-1 mb-3 flex-grow-1 text-center",
  },
});
const app = useApp();
const route = useRoute();
const auth = useAuth();
const filters = reactive({});
//init list page hook
const page = useListPage(props, filters);
//page state
const {
  totalRecords, // total records from api - Number
  recordCount, // current record count - Number
  loading, // Api loading state - Boolean
  selectedItems, // Data table selected items -Array
  pagination, //Pagination object - Object
  searchText, // search text - String
  pageReady, // api data loaded successfully
} = toRefs(page.state);
//page computed propties
const {
  records, // page record from store - Array
  apiUrl, // current api path - URL
  currentRecord, // master detail selected record - Object
  pageBreadCrumb, // get page navigation paths - Object
  canLoadMore, // if api has more data for loading - Boolean
  finishedLoading, // if api has finished loading - Boolean
  totalPages, // total number of pages from api - Number
  recordsPosition, // current record position from api - Number
} = page.computedProps;
//page methods
const {
  load, // load data from api
  reload, // reset pagination and load data
  loadNextPage, // load next page
  loadPreviousPage, // load previous page
  exportPage, // export page records - args = (exportFormats, apiUrl, pageName)
  clearSearch, // clear input search
  debounce, // debounce input search
  onSort, // reset page number before sort from api
  deleteItem, // delete item by id or selected items - args = (id) or (selectedItems)
  setCurrentRecord, // master detail set current record
  isCurrentRecord, // master detail
  removeFilter, // remove page filter item - args = (filter.propertyname)
  getFilterLabel, // get filter item display label - args = (filter.propertyname)
  filterHasValue, //check if filter item has value - args = (filter.propertyname)
  importComplete, // reload page after data import
} = page.methods;
function getActionMenuModel(data) {
  return [
    {
      label: "View",
      to: `/complaints/view/${data.complaint_id}`,
      icon: "pi pi-eye",
      visible: auth.canView("complaints/view"),
    },
    {
      label: "Update Ticket",
      command: (event) => {
        app.openPageDialog({
          page: "complaints/edit",
          url: `/complaints/edit/${data.complaint_id}`,
          closeBtn: true,
          persistent: true,
          position: "bottom",
        });
      },
      icon: "pi pi-pencil",
      visible: auth.canView("complaints/edit"),
    },
  ];
}
watch(props.refreshToken, () => {
  console.log("_____________", props.refreshToken);
  // load();
});

onMounted(() => {
  const pageTitle = "Complaints";
  app.setPageTitle(props.routeName, pageTitle);
  load();
});
</script>
<style scoped></style>
